/* eslint-disable */
export default {
  header: 'Entrar em contato com o suporte',
  toggleTitle: '1. Ative o modo de rastreamento de erros',
  toggleDescription:
    'Isso nos ajudará a localizar os problemas, mas pode afetar um pouco o desempenho do aplicativo.',
  downloadTitle:
    '2. Baixe o registro de erros depois de reproduzir o problema.',
  downloadButton: 'Baixar',
  downloadDisabledTitle:
    'Ative o modo de rastreamento de erros antes de baixar o registro de erros.',
  sendTitle: '3. Envie o registro para a equipe de suporte',
  createSupportTicket: 'Crie um tíquete de suporte',
  sendDescription:
    ' para entrar em contato com a nossa equipe de suporte. Em seguida, envie o registro para a equipe de suporte para solucionar o problema.',
  privacyNotice:
    'Ao baixar e nos enviar o registro, você permite que o RingCentral acesse determinadas informações relacionadas a registros para solucionar problemas e corrigir erros. Para saber mais sobre como a RingCentral processa dados pessoais, veja nossos ',
  privacyNoticeLink: 'Termos de serviço',
  and: ' e ',
  privacyNoticeEnd: 'Aviso de privacidade.',
  needLeavePage:
    'Você pode sair desta página durante a execução do rastreamento de erros. Depois de reproduzir o problema, retorne a esta página e baixe os arquivos de registro.',
  downloading: 'Baixando',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
